import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import { formatCurrency } from 'src/helpers/formatters'
import { Button } from 'src/Components'

const HIGH_LTV_FLOOR = 82

const PayingDownButton = props => (
  <Button minimal {...props}>
    <FormattedMessage
      id='Homeowner.mortgageInsurance.payingDownButton'
      defaultMessage='Paying down principal'
    />
  </Button>
)

const ConfirmValueButton = props => (
  <Button minimal {...props}>
    <FormattedMessage
      id='Homeowner.mortgageInsurance.confirmValueButton'
      defaultMessage='confirm your value on homebot'
    />
  </Button>
)

const AdditionalInfo = ({ avm, ltvPercent }) => {
  if (ltvPercent > HIGH_LTV_FLOOR) {
    return (
      <Fragment>
        <h3>
          <FormattedMessage
            id='Homeowner.mortgageInsurance.highLTVinfo.headline'
            defaultMessage='There are a few ways to accelerate this.'
          />
        </h3>
        <ol className='default'>
          <li>
            <strong>
              <FormattedMessage
                id='Homeowner.mortgageInsurance.LTVinfo.talkToLender'
                defaultMessage='Talk to your lender:'
              />
            </strong>{' '}
            <FormattedMessage
              id='Homeowner.mortgageInsurance.highLTVinfo.talkToLenderPara'
              defaultMessage='They can help explain your options to remove mortgage insurance from your loan. Qualifying for removal of mortgage insurance can depend on the original value of your home, the current home value based on Fannie Mae or Freddie Mac’s valuation (which may differ from your Homebot estimate), the age of the loan, property type, your payment history and more. Things can get pretty complicated quickly, so it’s best if you ask for advice.'
            />
          </li>

          <li>
            <strong>
              <FormattedMessage
                id='Homeowner.mortgageInsurance.LTVinfo.confirmValue'
                defaultMessage='Double-check the value of your home'
              />
            </strong>{' '}
            <FormattedMessage
              id='Homeowner.mortgageInsurance.LTVinfo.confirmValuePara'
              defaultMessage='{homeValue} is just an estimate. You may need to pay for a professional appraisal or other valuation to qualify for mortgage insurance removal. Before you take that step, request an updated estimate to get an idea of your home’s current market value.'
              values={{
                homeValue: (
                  <span className='text-important'>{formatCurrency(avm)}</span>
                ),
                confirmValueButton: <ConfirmValueButton onClick={console.log} />
              }}
            />
          </li>

          <li>
            <strong>
              <FormattedMessage
                id='Homeowner.mortgageInsurance.highLTVinfo.improveValue'
                defaultMessage="Improve your home's value:"
              />
            </strong>{' '}
            <FormattedMessage
              id='Homeowner.mortgageInsurance.highLTVinfo.improveValuePara'
              defaultMessage='Certain major home improvements may help you drop mortgage insurance faster because they will increase your equity percentage. Not all home improvements are equally valuable. Your lender can tell you about specific requirements.'
            />
          </li>

          <li>
            <strong>
              <FormattedMessage
                id='Homeowner.mortgageInsurance.highLTVinfo.accelerateDate'
                defaultMessage='Accelerate the date:'
              />
            </strong>{' '}
            <FormattedMessage
              id='Homeowner.mortgageInsurance.highLTVInfo.accelerateDatePara'
              defaultMessage='{payingDownButton} can help speed up your ownership percentage.'
              values={{
                payingDownButton: <PayingDownButton onClick={console.log} />
              }}
            />
          </li>
        </ol>
      </Fragment>
    )
  }

  return (
    <Fragment>
      <h3>
        <FormattedMessage
          id='Homeowner.mortgageInsurance.LTVinfo.headline'
          defaultMessage='There are a couple things you should do.'
        />
      </h3>
      <ol className='default'>
        <li>
          <strong>
            <FormattedMessage
              id='Homeowner.mortgageInsurance.LTVinfo.talkToLender'
              defaultMessage='Talk to your lender:'
            />
          </strong>{' '}
          <FormattedMessage
            id='Homeowner.mortgageInsurance.LTVinfo.talkToLenderPara'
            defaultMessage='They can help explain your options to remove mortgage insurance from your loan. Qualifying for removal of mortgage insurance can depend on the original value of your home, the current home value based on Fannie Mae or Freddie Mac’s valuation (which may differ from your Homebot estimate), the age of the loan, property type, your payment history and more. Things can get pretty complicated quickly, so it’s best if you ask for advice.'
          />
        </li>
        <li>
          <strong>
            <FormattedMessage
              id='Homeowner.mortgageInsurance.LTVinfo.confirmValue'
              defaultMessage='Double-check the value of your home'
            />
          </strong>{' '}
          <FormattedMessage
            id='Homeowner.mortgageInsurance.LTVinfo.confirmValuePara'
            defaultMessage='{homeValue} is just an estimate. You may need to pay for a professional appraisal or other valuation to qualify for mortgage insurance removal. Before you take that step, request an updated estimate to get an idea of your home’s current market value.'
            values={{
              homeValue: (
                <span className='text-important'>{formatCurrency(avm)}</span>
              ),
              confirmValueButton: <ConfirmValueButton onClick={console.log} />
            }}
          />
        </li>
      </ol>
    </Fragment>
  )
}

export default AdditionalInfo
